import FirstScreen from './screens/firstScreen/firstScreen';
import SecondScreenB from './screens/secondScreenB/secondScreenB';
import ThirdScreen from './screens/thirdScreen/thirdScreen';
import CoursesScreen from './screens/coursesScreen/coursesScreen';

import CalculatorScreen from './screens/calculatorScreen/calculatorScreen';
import FitVsScreen from './screens/fitVsScreen/fitVsScreen';
import DecisionScreen from './screens/decisionScreen/decisionScreen';
import FaqScreen from './screens/faqScreen/faqScreen';
import ShortsScreen from './screens/shortsScreen/shortsScreen';
import SocialProofScreen from './screens/socialProofScreen/socialProofScreen';
import Footer from './components/footer/Footer';
import FloatingCta from './components/floatingCta/FloatingCta';

import Navbar from './components/nav/nav';
import LoadingScreen, { usePageLoader } from './components/loadingScreen/LoadingScreen';
import romiImg from './images/romi-hero2.webp';

function WrapperB() {
  const { loaded, hiding, progress } = usePageLoader(romiImg);

  return (
    <>
      {!loaded && <LoadingScreen progress={progress} hiding={hiding} />}
      {loaded && (
        <div className="wrapper">
          <Navbar />
          <FirstScreen />
          <SecondScreenB />
          <ThirdScreen />
          <SocialProofScreen />
          <CoursesScreen />
          <FitVsScreen />
          <CalculatorScreen />
          <DecisionScreen />
          <FaqScreen />
          <ShortsScreen />
          <Footer />
          <FloatingCta />
        </div>
      )}
    </>
  );
}

export default WrapperB;
